import { PropsWithChildren } from 'react';

import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { cn } from '@/utils/cn-tw-merge';

interface FilterSectionProps {
  label: string;
  labelId?: string;
  className?: string;
}

export function FilterSection({ label, labelId, className, children }: PropsWithChildren<FilterSectionProps>) {
  return (
    <section className={cn('flex flex-col gap-4', className)}>
      <Typography
        as="h3"
        id={labelId}
        variant={TypographyVariant.MEDIUM_BODY_TEXT}
        className="font-semibold text-gray-700"
      >
        {label}
      </Typography>
      {children}
    </section>
  );
}
